import { render, staticRenderFns } from "./card-status-change.vue?vue&type=template&id=f91cf62e&scoped=true"
import script from "./card-status-change.vue?vue&type=script&lang=js"
export * from "./card-status-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91cf62e",
  null
  
)

export default component.exports